import React, { useEffect } from "react";
import classes from "./ProfileComponents.module.scss";
import { useFormContext, Controller } from "react-hook-form";
import WarningTooltip from "./WarningTooltip";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useTranslation } from 'react-i18next';


const Accounts = ({
  isEditMode,

  onFormReset,
  shouldReset,
}) => {
  const { t } = useTranslation();
  const {
    register,
    reset,
    control,
    formState: { errors },
  } = useFormContext();

  useEffect(() => {
    if (shouldReset) {
      reset();
      onFormReset();
    }
  }, [shouldReset, reset, onFormReset]);

  return (
    <>
      <h3 className={classes.subtitle}>{t("Bank Accounts information")}
        <OverlayTrigger placement="top" overlay={<Tooltip>{t(" Enter bank account information, that will be visible on your invoices (if you select bank transfer as a payment method).")}</Tooltip>}>
          <HelpOutlineIcon style={{marginLeft:"0.3rem", fontSize:"1rem"}}/>
        </OverlayTrigger>
      </h3>
      <div className={classes.container}>
        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="typePan">
            {t("Type PAN")}
            <OverlayTrigger placement="top" overlay={<Tooltip>{t("If bank account number is not provided when creating invoices, which should we use as default?")}</Tooltip>}>
              <HelpOutlineIcon style={{marginLeft:"0.3rem", fontSize:"1rem"}}/>
            </OverlayTrigger>
          </label>
          <Controller
            name="TypePAN"
            id="TypePAN"
            control={control}
            render={({ field }) => {
              return (
                <select {...field} onChange={(e) =>{
                  field.onChange(e);
                }}>
                      <option value="BBAN" key="BBAN">
                        BBAN
                      </option>
                      <option value="IBAN" key="IBAN">
                        IBAN
                      </option>
                </select>
              );
            }}
          />
          <p className={classes.error}>{errors.CurrencyCode?.message}</p>
        </fieldset>

        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="IBAN">IBAN
          {errors.IBAN && <>
              <WarningTooltip text={errors.IBAN?.message}/>
              
            </>}</label>
          <input
            type="text"
            name="IBAN"
            id="IBAN"
            style={errors.IBAN ? {outlineColor:"red"}: {}}
            {...register("IBAN")}
            placeholder="IBAN"
          />
        </fieldset>

        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="conPhone">BIC/SWIFT Code (if you choose IBAN)
          {errors.IBANBICCode && <>
              <WarningTooltip text={errors.IBANBICCode?.message}/>
              
            </>}</label>
          <input
            type="text"
            name="IBANBICCode"
            id="IBANBICCode"
            style={errors.IBANBICCode ? {outlineColor:"red"}: {}}
            {...register("IBANBICCode")}
            placeholder="IBANBICCode"
          />
        </fieldset>


        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="BBAN">BBAN
          {errors.BBAN && <>
              <WarningTooltip text={errors.BBAN?.message}/>
              
            </>}</label>
          <input
            type="text"
            name="BBAN"
            id="BBAN"
            style={errors.BBAN ? {outlineColor:"red"}: {}}
            {...register("BBAN")}
            placeholder="BBAN"
          />
        </fieldset>

        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="conEmail">BIC/SWIFT Code (if you choose BBAN)
          {errors.BBANBICCode && <>
              <WarningTooltip text={errors.BBANBICCode?.message}/>
              
            </>}</label>
          <input
            type="text"
            name="BBANBICCode"
            id="BBANBICCode"
            style={errors.BBANBICCode ? {outlineColor:"red"}: {}}
            {...register("BBANBICCode")}
            placeholder="BBANBICCode"
          />
        </fieldset>
      </div>
    </>
  );
};

export default Accounts;
